export default __webpack_public_path__ + "static/media/400.c029a468.png";